import { useState, useEffect,useMemo } from "react";
import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { Button } from "@material-ui/core";
import Spacer from "../../components/Spacer";
import MainContainer from "../../components/MainContainer";
import { headerGardian } from "../../data/gardian_header";
import PersonnelService from "../../services/PersonnelService";
import { userDetailContext } from "../../App";
import { useContext } from "react";
import { hasPrivilege } from "../../utils/privilege";
import { useNavigate } from 'react-router-dom';
import PlanningMissionService from "../../services/PlanningMissionService";
import UserService from "../../services/UserService";
import {TextField} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SearchIcon from '@mui/icons-material/Search';
import LoadingButton from '@mui/lab/LoadingButton';
import GardianService from "../../services/GardianService";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { 
    Box, 
    Typography, 
     Accordion,
      AccordionSummary,
      AccordionDetails,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
     FormControl,
    MenuItem,
    Select,
  } from '@mui/material';
  import { DatePicker } from '@mui/x-date-pickers';
  import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
  import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
  import { format, addMonths, subMonths, getYear , setDate} from 'date-fns';
  import frLocale from 'date-fns/locale/fr';
  import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
  import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
  button: {
    float: 'right',
  },
}));

export default function GardianVisual() {
  const navigate = useNavigate();
  const classes = useStyles();
  const contextData = useContext(userDetailContext);
  const [direction,setDirection]=useState([]);
   const [selectedDirection, setSelectedDirection] = useState('all');
   const [isLoading, setIsLoading] = useState(false);
   const [personnelData,setPersonnelData]=useState([]);
   const [selectuser,setSelectuser]=useState(null);
   const [openLoadingSimpleBackdrop,setOpenLoadingSimpleBackdrop]=useState(false);

    const currentYear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [currentMonth, setCurrentMonth] = useState(new Date());
    const [selections, setSelections] = useState({});

    const [selectUser, setSelectUser] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [pendingSelection, setPendingSelection] = useState(null);
     const [expanded, setExpanded] = useState({});

    // Génère les années du currentYear jusqu'à aujourd'hui
    const years = Array.from({ length: currentYear - 2024 }, (_, i) => 2025 + i);

  //     const days = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

  // const handleCheckboxChange = (personId, userId, day) => {
  //   setSelections(prev => ({
  //     ...prev,
  //     [`${personId}-${day}`]: !prev[`${personId}-${day}`]
  //   }));
  // };

  const handleAccordionChange = (name) => (event, isExpanded) => {
    setExpanded(prev => ({
      ...prev,
      [name]: isExpanded
    }));
  };

    const [dialogContent, setDialogContent] = useState({
      title: '',
      content: null
    });


 
  // Génère les jours du mois
  const daysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return new Date(year, month + 1, 0).getDate();
  };

  const days = Array.from({ length: daysInMonth(currentMonth) }, (_, i) => i + 1);

    const handleMonthChange = (increment) => {
      setCurrentMonth(increment ? addMonths(currentMonth, 1) : subMonths(currentMonth, 1));
        const newMonth = increment ? addMonths(currentMonth, 1) : subMonths(currentMonth, 1);

        
        setCurrentMonth(newMonth);
        setSelectedYear(newMonth.getFullYear());
   
      
        setOpenLoadingSimpleBackdrop(true);
        GardianService.listeadd(selectedDirection,format(increment ? addMonths(currentMonth, 1) : subMonths(currentMonth, 1), 'M'),selectedYear).then((result) => {
                  if (result && result.data) {   
                    setPersonnelData(result.data);
                    setSelections(result.selection);
                    setOpenLoadingSimpleBackdrop(false);
                  }
                  }).catch((error) => {
                    setPersonnelData([]);
                    setSelections([]);
                    setOpenLoadingSimpleBackdrop(false);
                  });
          
    };

    const handleCheckboxChange = (personId, userId, day) => {
      // setPendingSelection({
      //   personId,
      //   userId,
      //   day,
      //   newValue: !selections[`${personId}-${day}`]
      // });
      //setOpenDialog(true);

        setSelections(prev => ({
          ...prev,
          [`${personId}-${day}`]: !selections[`${personId}-${day}`]
        }));
    };

          const handleConfirm = () => {

                const allSelectedPersons = [];

                Object.entries(groupedData).forEach(([groupName, personGroup]) => {
                  const personsWithSelections = personGroup.filter(person => 
                    days.some(day => selections[`${person.id}-${day}`]) && selectUser === person.user_id
                  );
                  
                  allSelectedPersons.push(...personsWithSelections);
                });
                
                console.log("all",allSelectedPersons);

                const filteredSelections = {};

                // Récupérer tous les ids des personnes sélectionnées
                const selectedIds = allSelectedPersons.map(person => person.id);

                // Filtrer les selections
                Object.entries(selections).forEach(([key, value]) => {
                  const [idStr, day] = key.split('-');
                  const id = parseInt(idStr);
                  
                  if (selectedIds.includes(id) && value === true) {
                    filteredSelections[key] = value;
                  }
                });

                GardianService.add(format(currentMonth, 'M'),selectedYear,filteredSelections,selectUser).then((result) => {
                  if (result && result.data) {   
                   // setPersonnelData(result.data);
                  }
                  }).catch((error) => {
                    //setPersonnelData([]);
                  }); 
              
               
              
     };



    const handleCancel = () => {
      setOpenDialog(false);
      setPendingSelection(null);
    };
  
  useEffect(() => {
        const userData = localStorage.getItem('USER');
        if (userData) {
        UserService.getUserSummaryByUserId(userData)
            .then((result) => {
            if (result && result.data) {
                const dirpers = result.data.direction_id;
                 setSelectedDirection(dirpers);
                  setOpenLoadingSimpleBackdrop(true);
                GardianService.listeadd(dirpers,format(currentMonth, 'M'),selectedYear).then((result) => {
                  if (result && result.data) {   
                    setPersonnelData(result.data);
                    setSelections(result.selection);
                    setOpenLoadingSimpleBackdrop(false);
                  }
                  }).catch((error) => {
                    setPersonnelData([]);
                    setSelections([]);
                    setOpenLoadingSimpleBackdrop(false);
                  });

                    PlanningMissionService.getDirection().then((result) => {
                          if (result && result.data) {
                                  if (parseInt(dirpers, 10) === 1) { 
                                      setDirection(result.data);
                                      setSelectedDirection(dirpers);
                                  } else {
                                  setSelectedDirection(dirpers);
                                  setDirection(result.data.filter(ts => parseInt(ts.direction_id, 10) === parseInt(dirpers, 10)));
                            }
                         }
                        }).catch((error) => {
                        console.error('Error fetching direction data:', error);
                     });
            }
            })
            .catch((error) => {

            });
        }
    }, []);

     const directionOptions = useMemo(() => {
        if (direction.length === 1) return direction;
                return [ ...direction];
        }, [direction]);
    const defaultValue = useMemo(() => {
        if (direction.length === 1) return direction[0];
        return null;
    }, [direction]);

    const groupedData = personnelData.reduce((acc, person) => {
        if (!acc[person.name]) acc[person.name] = [];
        acc[person.name].push(person);
        return acc;
      }, {});

  const handleDirectionChange = (event) => {
    setSelectedDirection(event.target.value);
  };


  const handlefilter = async () => {
       GardianService.listeadd(selectedDirection,format(currentMonth, 'M'),selectedYear).then((result) => {
                  if (result && result.data) {   
                    setPersonnelData(result.data);
                    setSelections(result.selection);
                  }
                  }).catch((error) => {
                    setPersonnelData([]);
                    setSelections([]);
      });
  };


  return (
    <MainContainer {...headerGardian}>
       <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      <Spacer y={2} />
      <Grid container spacing={3}>

        <Grid item xs={12}>
          <Paper className={classes.paper} variant="outlined">
              <Box sx={{ p: 3 }}>
               {/* <Typography variant="h5" gutterBottom style={{textAlign:"center"}}>Suivi des jours de repos</Typography> */}
               <Spacer y={2} />
                        <Grid container item xs={12}>
                            <Grid item xs={12}>
                            </Grid>
                            <Grid item xs={4}>
                                 <FormControl fullWidth variant="outlined" size="small">
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="direction_id"
                                    style={{ width: "300px" }}
                                    value={selectedDirection || ''} 
                                    onChange={handleDirectionChange}
                                    displayEmpty
                                  >
                                    <MenuItem value="" disabled>
                                      Sélectionner une direction
                                    </MenuItem>
                                    {directionOptions.map((row) => (
                                      <MenuItem key={row.direction_id} value={row.direction_id}>
                                        {row.name} ({row.code})
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>

                            </Grid>
                             <Spacer x={2} />
                             <Grid item xs={2}>
                                <LoadingButton
                                      fullWidth
                                      variant="contained"
                                      color="primary"
                                      loading={isLoading} 
                                      loadingPosition="start"
                                      startIcon={<SearchIcon />}
                                      onClick={handlefilter} 
                                >
                                       {isLoading ? 'Chargement...' : 'Filtrer'}
                                </LoadingButton>
                            </Grid>
                            <Grid item xs={4}>

                            </Grid>
                            <Spacer y={10} />
                            <Grid item xs={4}>
                            </Grid>
                            <Grid item xs={8}>    
                                <Box sx={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    mb: 3,
                                    gap: 2 
                                }}>
                                    <Button 
                                        variant="contained" 
                                        onClick={() => handleMonthChange(false)}
                                        sx={{ 
                                            mr: 2,
                                            px: 3, 
                                            py: 1.5
                                        }}
                                    >
                                        <ArrowBackIosIcon/>
                                    </Button>
                                    
                                    <Typography 
                                        variant="h6"
                                        sx={{
                                            textTransform: 'uppercase', 
                                            fontWeight: 'bold', 
                                            letterSpacing: '0.5px',
                                            mx: 2 
                                        }}
                                    >
                                        {format(currentMonth, 'MMMM yyyy', { locale: frLocale })}
                                    </Typography>
                                    
                                    <Button 
                                        variant="contained" 
                                        onClick={() => handleMonthChange(true)}
                                        sx={{ 
                                            ml: 2,
                                            px: 3, 
                                            py: 1.5
                                        }}
                                    >
                                    <ArrowForwardIosIcon/>
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid item xs={3}>   
                                  <Box
                                     component="span"
                                     sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)', width: '15px', height: '15px', background: '#ffeb3b' }}
                                   >
                                    </Box>
                                     Temps de repos/congé
                            </Grid>
                            <Grid item xs={3}>   
                                  <Box
                                     component="span"
                                     sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)', width: '15px', height: '15px', background: '#f44336' }}
                                   >
                                    </Box>
                                     Temps d'absence
                            </Grid>
                             <Grid item xs={3}>   
                                  <Box
                                     component="span"
                                     sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)', width: '15px', height: '15px', background: '#4caf50' }}
                                   >
                                    </Box>
                                      Temps de présence
                            </Grid>
                            <Grid item xs={3}>   
                                  <Box
                                     component="span"
                                     sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)', width: '15px', height: '15px', background: '#ADD8E6' }}
                                   >
                                    </Box>
                                      Temps de travaille
                            </Grid>
                            <Grid item xs={12}>  
                            </Grid>
                               <Grid item xs={12}>  
                            </Grid>
                        </Grid>
                            <Spacer y={2}/>
                            <Spacer y={2}/>
                            <Box sx={{ width: '100%' }}>
                               <TableContainer component={Paper}>
                                <Table sx={{ tableLayout: 'fixed', minWidth: 'max-content' }}>
                                    <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ width: 120, fontWeight: 'bold' }}>Gardien</TableCell>
                                        <TableCell sx={{ width: 150, fontWeight: 'bold' }}>Type</TableCell>
                                        {days.map(day => (
                                        <TableCell 
                                            key={day} 
                                            align="center" 
                                            sx={{ 
                                            width: 20,
                                            fontWeight: 'bold',
                                            padding: '6px' 
                                            }}
                                        >
                                            {day}
                                        </TableCell>
                                        ))}
                                    </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {Object.entries(
                                        personnelData.reduce((acc, person) => {
                                        if (!acc[person.name]) acc[person.name] = [];
                                        acc[person.name].push(person);
                                        return acc;
                                        }, {})
                                    ).map(([name, personGroup], groupIndex) => (
                                        <React.Fragment key={`${name}-${groupIndex}`}>
                                        {personGroup.map((person, personIndex) => (
                                            <TableRow key={`${person.id}-${personIndex}`}>
                                            {personIndex === 0 && (
                                                <TableCell 
                                                rowSpan={personGroup.length} 
                                                sx={{ 
                                                    width: 120,
                                                    verticalAlign: 'top',
                                                    backgroundColor: '#f8f9fa'
                                                }}
                                                >
                                                {name}
                                                </TableCell>
                                            )}
                                            <TableCell sx={{ width: 150 }}>{person.type}</TableCell>
                                            {/* {days.map(day => (
                                               <TableCell 
                                                    key={day} 
                                                    align="center" 
                                                    sx={{ 
                                                        width: 20,
                                                        padding: '6px',
                                                        height: '48px',
                                                        backgroundColor: !selections[`${person.id}-${day}`] ? '#ADD8E6' : (selections[`${person.id}-${day}`]==="present")?'#008000':'yellow',
                                                        border: '1px solid #ddd'
                                                    }}
                                                >
                                                </TableCell>
                                            ))} */}
                                            {days.map(day => {
                                                  const key = `${person.id}-${day}`;
                                                  const value = selections[key];

                                                  const today = new Date();
                                                  const currentDate = new Date(currentMonth);
                                                  currentDate.setDate(day);
                                                  currentDate.setHours(0, 0, 0, 0); 

                                                  let bgColor = '#ADD8E6'; 
                                                  if (value === "present") {
                                                    bgColor = '#4caf50'; 
                                                  } else if (value) {
                                                    bgColor = '#ffeb3b'; 
                                                  } else if (currentDate < today) {
                                                    bgColor = '#f44336'; 
                                                  }

                                                  return (
                                                    <TableCell 
                                                      key={day} 
                                                      align="center"
                                                      sx={{
                                                        width: 20,
                                                        padding: '6px',
                                                        height: '48px',
                                                        backgroundColor: bgColor,
                                                        border: '1px solid #ddd'
                                                      }}
                                                    >
                                                    </TableCell>
                                                  );
                                                })}

                                            </TableRow>
                                        ))}
                                        </React.Fragment>
                                    ))}
                                    </TableBody>
                                </Table>
                                </TableContainer>
                                </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </MainContainer>
  );
}
